import { useCallback } from 'react';
import { useClient } from 'hooks/useClient';
import { useMutation } from 'react-query';
import { ITeamFolderPayload } from '@cincel/client';
import { useToast } from '@chakra-ui/react';
import { ERROR_TOAST_DEFAULTS, SUCCESS_TOAST_DEFAULTS } from '@helpers';
import fp from 'lodash/fp';
import { translations } from 'translations';
import { useTranslation } from 'react-i18next';
import { useSession } from 'store/session';
import { AxiosError } from 'axios';
import { getSessionTokenV3 } from 'helpers/sessionContext';


export const usePatch = () => {
  const client = useClient({
    token: getSessionTokenV3() as string,
    url: process.env.REACT_APP_API_V3,
  });

  const toast = useToast();

  const { t } = useTranslation();

  const { team } = useSession();

  const uuid = team?.uuid as string;

  const fn = async (payload: ITeamFolderPayload) => {
    await client.patchTeamFolder(
      uuid,
      fp.get('uuid')(payload),
      fp.pick(['name'])(payload),
    );

    const MESSAGE = t(translations.FOLDERS_PAGES.PATCH_SUCCESS);

    toast({ ...SUCCESS_TOAST_DEFAULTS, title: MESSAGE });
  };

  const onError = useCallback(
    (error: AxiosError) => {
      let msg = t(translations.ERRORS.NETWORK_DEFAULT);

      if (error?.response?.status === 403) {
        msg = t(translations.ERRORS.PERMISSIONS);
      }

      if (error?.response?.status === 409) {
        msg = t(translations.FOLDERS_PAGES.STATUS_CODE_409);
      }
      toast({ ...ERROR_TOAST_DEFAULTS, title: msg });
    },
    [t, toast],
  );

  const mutation = useMutation(['patch-team-folder', uuid], fn, { onError });

  return { ...mutation };
};
